import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { changeHistoryStore } from 'utils/MobxDataManager/singletons';
import { ChangeHistoryPromotionRequestDelete } from 'nomst/Stores/ChangeHistory/changeHistoryPromotionRequestDelete';
import { formatTimestamp } from 'utils/dateUtils';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import { NavigationStore } from 'nomst/Stores/Navigation/navigation.store';
import {  ReportsView} from 'typings/enums';

export interface IChangeHistoryPromotionRequestViewProps {
    configuration: Configuration;
    navigationStore: NavigationStore;
    timestamp: string;
    changeHistoryPromotionRequestDelete: Nullable<ChangeHistoryPromotionRequestDelete>;
}

export class ChangeHistoryPromotionRequestDeleteView
    extends React.Component<IChangeHistoryPromotionRequestViewProps> {
    constructor(props: IChangeHistoryPromotionRequestViewProps) {
        super(props);
        this.handleGoToEmployeeDetailClick = this.handleGoToEmployeeDetailClick.bind(this);
    }
    render(): React.ReactNode {
        const { changeHistoryPromotionRequestDelete, timestamp } = this.props;
        if (!changeHistoryPromotionRequestDelete) {
            return null;
        }

        return (
            <div className="history-item flex-row">
                <div className="initials-border">
                    <div className="initials-sm">
                        {changeHistoryPromotionRequestDelete.modifyingUser.displayInitial}
                    </div>
                    <div className="dot-border" />
                </div>
                <div className="history-item-content">
                    <div className="flex-row history-top">
                        <span>{formatTimestamp(timestamp)}</span>
                    </div>
                    <strong className="display-name">
                        {changeHistoryPromotionRequestDelete.modifyingUser.displayName}
                    </strong> deleted Promotion Request for &#32;
                    <button
                        className="pxl-link"
                        onClick={this.handleGoToEmployeeDetailClick}
                    >{changeHistoryPromotionRequestDelete.employee.displayName}
                    </button>
                    <div className="row flex-row" />
                </div>
            </div>
        );
    }

    private handleGoToEmployeeDetailClick(): void {
        const { navigationStore, configuration } = this.props;
        const { changeHistoryPromotionRequestDelete } = this.props;

        navigationStore.navigateToEmployee(
            configuration.cycleId,
            changeHistoryStore.manager.employeeSourceId,
            null,
            changeHistoryPromotionRequestDelete?.employee.employeeSourceId,
            ReportsView.DirectsOnly);
    }
}

export default inject('store')(observer(ChangeHistoryPromotionRequestDeleteView));